import type { TaskNoteDraft } from "~mobile/events/helpers/taskNoteDraft";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { isTaskNoteDraftDirty, rehydrateTaskNoteDraft } from "~mobile/events/helpers/taskNoteDraft";

export interface EventsNoteDraftState {
	byTask: Record<string, TaskNoteDraft>;
}

const initialState: EventsNoteDraftState = {
	byTask: {}
};

export const eventsNoteDraftSlice = createSlice({
	initialState,
	name: "eventsNoteDraft",
	reducers: {
		patchTaskNoteDraft: (state, action: PayloadAction<{ draft: Partial<TaskNoteDraft>; taskId: string }>) => {
			const merged = { ...rehydrateTaskNoteDraft(state.byTask[action.payload.taskId]), ...action.payload.draft };
			if (isTaskNoteDraftDirty(merged)) {
				state.byTask[action.payload.taskId] = merged;
			} else {
				delete state.byTask[action.payload.taskId];
			}
		}
	}
});

export const { patchTaskNoteDraft } = eventsNoteDraftSlice.actions;

export default eventsNoteDraftSlice.reducer;
